import * as React from 'react';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { ListWrapper } from './components/list-wrapper';
import { ListRenderer } from './components/list-renderer';
import { actionCreators } from './actions';
import { subscriberGroupsTranslation } from '../constants';
import { SubscriberGroupsState } from '../types-store';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import {
  MergeSubscriberGroupContainer
} from 'app/area/subscriber-groups/shared/merge-subscriber-group/merge-subscriber-group-container';

export type SubscriberGroupsListProps = DefaultContainerProps
  & SubscriberGroupsState
  & typeof actionCreators;

class SubscriberGroupsListComponent extends React.PureComponent<SubscriberGroupsListProps> {
  public static statePath: string = STATE.subscriberGroups;

  public componentWillUnmount() {
    this.props.clearList();
  }

  public componentDidMount() {
    scrollToTop();
  }

  public render() {

    const { list, sharedState, translation, list: { mergeSubscriberGroup, subscriberGroupOptions, validation },
      updateMergeSubscriberGroup, loadSubscriberGroupOptions, deleteMergeSubscriberGroup, resetValidation, 
      updateValidation, loadSubscriberGroupList, displayError
    } = this.props;

    return <ListWrapper
      displayError={displayError}
      sharedState={sharedState}
      translation={translation}>
      <ListRenderer
        updateMergeSubscriberGroup={updateMergeSubscriberGroup}
        mergeSubscriberGroup={mergeSubscriberGroup}
        listState={list}
        loadList={loadSubscriberGroupList}
        translation={translation} />
      <MergeSubscriberGroupContainer
        mergeSubscriberGroup={mergeSubscriberGroup}
        subscriberGroupOptions={subscriberGroupOptions}
        translation={translation}
        validation={validation}
        deleteMergeSubscriberGroup={deleteMergeSubscriberGroup}
        loadOptions={loadSubscriberGroupOptions}
        updateMergeSubscriberGroup={updateMergeSubscriberGroup}
        resetValidation={resetValidation}
        updateValidation={updateValidation} />
    </ListWrapper>;
  }
}

const container = containerFactory(SubscriberGroupsListComponent, actionCreators, undefined, subscriberGroupsTranslation);

export { container as SubscriberGroupsList };
